var BaseView = require('../../../templates/sub-categories');

module.exports = BaseView.extend({
  TemplatesView: require('./templates')
});
